import { Loader2 } from "lucide-react";
import { Button } from "./Button";
import type { ReactNode } from "react";

interface LoadingButtonProps {
  loading: boolean;
  loadingText?: string;
  children: ReactNode;
  variant?: "primary" | "secondary";
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
  fullWidth?: boolean;
}

export function LoadingButton({
  loading,
  loadingText,
  children,
  variant = "primary",
  type = "button",
  disabled = false,
  onClick,
  className = "",
  fullWidth = false,
}: LoadingButtonProps) {
  return (
    <Button
      type={type}
      variant={variant}
      disabled={loading || disabled}
      onClick={onClick}
      className={className}
      fullWidth={fullWidth}
    >
      {loading ? (
        <div className="flex items-center justify-center gap-2">
          <Loader2 className="w-4 h-4 animate-spin" />
          {loadingText && <span>{loadingText}</span>}
        </div>
      ) : (
        children
      )}
    </Button>
  );
}

